import type { DailyMetricComparison } from '@/domain/health/selectors'
import { kgToLb } from '@/domain/health/units'

export function DailyMetricChange({ comparison, type, unit }: { comparison?: DailyMetricComparison; type: 'weight' | 'bodyFat'; unit: 'kg' | 'lb' }) {
  if (!comparison) return null
  const { current, previous } = comparison
  if (!current || !previous) return <p className="daily-change daily-change--missing" aria-label={!current ? '暂无记录' : '仅有一天记录 · 暂不比较'}>—</p>
  const display = (value: number) => type === 'weight' && unit === 'lb' ? kgToLb(value) : value
  const delta = (Math.round(display(current.value) * 10) - Math.round(display(previous.value) * 10)) / 10
  const direction = delta > 0 ? 'up' : delta < 0 ? 'down' : 'same'
  const suffix = type === 'bodyFat' ? '个百分点' : unit
  const baseline = comparison.isYesterday === false ? '上次' : '昨日'
  const text = delta === 0 ? `与${baseline}持平` : `较${baseline}${delta > 0 ? '上升' : '下降'} ${Math.abs(delta).toFixed(1)} ${suffix}`
  const dates = comparison.currentDay && comparison.previousDay ? `${comparison.currentDay} 对比 ${comparison.previousDay}` : ''
  return <p className={`daily-change daily-change--${direction}`} aria-label={text} aria-description={dates || undefined} title={[text, dates].filter(Boolean).join(' · ')}>
    <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d={delta > 0 ? 'M12 20V4m-6 6 6-6 6 6' : delta < 0 ? 'M12 4v16m-6-6 6 6 6-6' : 'M4 12h16m-6-6 6 6-6 6'} />
    </svg>
    <span aria-hidden="true">{Math.abs(delta).toFixed(1)}</span>
  </p>
}
